import LandingFormWrapper from 'components/landingFormWrapper/LandingFormWrapper';
import { black, textGray } from 'modules/colors';
import media from 'modules/media';
import { fonts, spacing } from 'modules/metrics';
import styled from 'styled-components';

export const LandingFormWrapperStyled = styled(LandingFormWrapper)`
  padding: 64px ${spacing.xl}px !important;
`;

export const Section = styled.div`
  padding-bottom: ${spacing.xl}px;
`;

export const SectionsTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const SectionsTitle = styled.h1`
  font-size: ${fonts.xl}px;
  color: ${black};
`;

export const TitleLine = styled.hr`
  background-color: ${textGray};
  height: 2px;
  border: 0;
  width: 100%;
  margin: ${spacing.md}px 0 ${spacing.xl}px 0;
`;

export const Text = styled.p`
  line-height: 22px;
  margin-bottom: ${spacing.xl}px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;

  ${media.tablet} {
    flex-direction: column;
    align-items: center;
  }
`;

export const Person = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;

  ${media.tablet} {
    width: 100%;
    padding: ${spacing.xl}px 0;
  }
`;

export const PersonImage = styled.img`
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  margin: 0 auto;
`;

export const PersonName = styled.h1`
  color: black;
  padding-top: ${spacing.xl}px;
  font-size: ${fonts.md}px;
`;

export const PersonRole = styled.h2`
  font-size: ${fonts.xs}px;
  padding-bottom: ${spacing.xl}px;
`;

export const PersonLine = styled(TitleLine)`
  margin: ${spacing.md}px 0;
`;

export const PersonText = styled.p``;
